export default {
    computed: {
        isSuperAdmin() {
            return this.$page.props.user ? !!this.$page.props.roles.includes('superadmin') : false;
        },

        isAdmin() {
            return this.$page.props.user
                ? !!this.$page.props.roles.includes('admin') || !!this.$page.props.roles.includes('superadmin')
                : false;
        },

        isWholesaler() {
            return this.$page.props.user ? this.$page.props.roles.includes('wholesaler') : false;
        },

        isRetailer() {
            return this.$page.props.user ? this.$page.props.roles.includes('retailer') : false;
        },

        isSalesperson() {
            return this.$page.props.user ? this.$page.props.roles.includes('salesperson') : false;
        },

        isKycSubmitted() {
            if (this.$page.props.user && this.$page.props.user.kyc_id) {
                return true;
            }
            return false;
        },

        kycVerified() {
            if (
                (this.isKycSubmitted &&
                    this.$page.props.user &&
                    this.$page.props.user.kyc &&
                    !!this.$page.props.user.kyc.accepted_at) ||
                this.isSalesperson
            ) {
                return true;
            }
            return false;
        },

        cmsView() {
            return !!this.$page.props.user && !this.isRetailer && !this.isSalesperson;
        },

        isDashboard() {
            return this.$page.url === '/';
        },
    },
};
